<template>
  <div class="limits-item">
    <span class="limits-item__title">
      <PlatformIcon :country="limits.country.code"/>
      {{ limits.country.label }}
    </span>

    <div class="limits-item__indicators">
      <span>
        <v-progress-linear
          rounded
          :model-value="dailyProgress"
          :color="dailyColor"
          :height="height"
        />

        <span class="limits-item__label">
          {{ dailyLimitLabel }}
        </span>
      </span>

      <span>
        <v-progress-linear
          rounded
          :model-value="weeklyProgress"
          :color="weeklyColor"
          :height="height"
        />

        <span class="limits-item__label">
          {{ weeklyLimitLabel }}
        </span>
      </span>
    </div>
  </div>
</template>

<script>
  import colors from 'vuetify/util/colors';
  import { isObj } from '../utils';
  import PlatformIcon from "@/components/PlatformIcon";

  export default {
    components: {
      PlatformIcon
    },
    props: {
      limits: {
        type: Object,
        default: () => ({})
      },
      height: {
        type: Number,
        default: 6
      },
    },
    data() {
      return {
        progress: 65,
        colors,
      };
    },
    computed: {
      dailyLimitLabel() {
        return `Daily (${this.daily} / ${this.maxDaily})`;
      },
      weeklyLimitLabel() {
        return `Weekly (${this.weekly} / ${this.maxWeekly})`;
      },
      daily() {
        return this.hasLimits ? this.limits.posted_deals_per_day : 0;
      },
      weekly() {
        return this.hasLimits ? this.limits.posted_deals_per_week : 0;
      },
      maxDaily() {
        return this.hasLimits ? this.limits.max_deals_per_day : 0;
      },
      maxWeekly() {
        return this.hasLimits ? this.limits.max_deals_per_week : 0;
      },
      dailyColor() {
        const { dailyProgress, colors } = this;

        return dailyProgress < 33
          ? colors.green.base
          : dailyProgress < 66
            ? colors.warning
            : colors.red.base;
      },
      weeklyColor() {
        const { weeklyProgress, colors } = this;

        return weeklyProgress < 33
          ? colors.green.base
          : weeklyProgress < 66
            ? colors.warning
            : colors.red.base;
      },
      dailyProgress() {
        const { daily, maxDaily } = this;
        return this.getProgress(daily, maxDaily);
      },
      weeklyProgress() {
        const { weekly, maxWeekly } = this;
        return this.getProgress(weekly, maxWeekly);
      },
      hasLimits() {
        return isObj(this.limits);
      },
    },
    methods: {
      getProgress(used, max) {
        return (used / max) * 100;
      },
    }
  };
</script>

<style lang="scss">
@use 'sass:map';
  @use '../assets/styles/theme' as *;

  .limits-item {
    display: flex;
    flex-wrap: wrap;
    font-size: 12px;
    line-height: 15px;
    gap: 8px;
    padding: 8px 16px;
    border-radius: $border-radius;
    background-color: rgb(var(--v-theme-surface));

    &__title {
      align-items: flex-end;
      display: flex;
      font-weight: bold;
      text-transform: uppercase;
      text-overflow: ellipsis;
      overflow: hidden;
      gap: 4px;
      max-width: 100%;
      white-space: nowrap;
      width: 100%;

      svg {
        height: 15px;
        min-width: 15px;
      }
    }

    &__indicators {
      display: flex;
      gap: 8px;
      width: 100%;

      > span {
        width: calc(50% - 4px);
      }
    }

    &__label {
      display: block;
      font-size: $text-size-sm;
      margin-top: 8px;
    }
  }
</style>
